import { useDraftPlotCommit } from './useDraftPlotCommit';
import { useDraftPlotsSearch } from './useDraftPlotsSearch';
import { usePanelResize } from './usePanelResize';

/**
 * Composes usePanelResize + useDraftPlotsSearch + useDraftPlotCommit into a single
 * return value for pages that need the full upload-plots panel.
 */
type UseDraftPlotsPanelOptions = {
  allOrgDrafts?: boolean;
  focusedPlotId?: string | null;
};

export const useDraftPlotsPanel = (panelState: string, options?: UseDraftPlotsPanelOptions) => {
  const resize = usePanelResize();

  const data = useDraftPlotsSearch({
    mapRef: resize.mapRef,
    mapLoaded: resize.mapLoaded,
    allOrgDrafts: options?.allOrgDrafts,
    focusedPlotId: options?.focusedPlotId,
  });

  const commit = useDraftPlotCommit({
    organizationId: data.organizationId,
    panelState,
    hasDraftPlots: data.allDraftPlots.length > 0,
  });

  return { ...resize, ...data, ...commit };
};
